import { SearchQueryOrderDirection } from "types/generated";

export const initialSortOption = "name";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export const ITEMS_LIMIT = 50;

export const FILTERS_ORDER_SETTINGS_KEY = "webhooksFiltersOrder";
